import { tick } from 'core/atoms/date-time';

export const mapStringToDate = (
  dateString: string | null | undefined,
): Date | undefined => {
  return (dateString ?? null) !== null ? tick(dateString).toDate() : undefined;
};
